<template>
  <div :class="clazz">
    <slot></slot>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Provide, Vue } from "vue-facing-decorator";

interface DisplayParams {
  showLabelOptional: boolean;
  showLabelRequired: boolean;
  suppressOffscreenOptional: boolean;
  suppressOffscreenRequired: boolean;
  showOptionalOnGroupFields: boolean;
}

@Component({ name: "ex" })
export default class Example extends Vue {
  @Prop(Object())
  public readonly text!: any;
  @Prop(Object())
  public readonly display!: DisplayParams;

  public clazz: string = "ds-ex";

  @Provide()
  resolveTxt(key: string, def: string): string {
    if (this.text && this.text[key]) {
      return this.text[key];
    }
    return def;
  }

  getDisplayParams(): DisplayParams {
    if (this.display) {
      return this.display;
    }
    return {
      showLabelOptional: true,
      showLabelRequired: false,
      suppressOffscreenOptional: false,
      suppressOffscreenRequired: true,
      showOptionalOnGroupFields: false
    };
  }

  @Provide()
  displayParams = this.getDisplayParams();

  @Provide()
  addContentClass(clazz: string) {
    this.clazz = clazz;
  }

  @Provide()
  getUserContext(): any {
    return {};
  }
}
</script>
